import React from "react";
import styled from "styled-components";



const MoleculeDataCard = ({
  selected,
  onClick,
  icon,
  title,
  desc,
  listItems,
  buttonSelected,
  onButtonClick,
  buttonText,
}) => (
  <DataCard selected={selected} onClick={onClick}>
    <div>
      <CardTitle>
        {icon} {title}
      </CardTitle>
      <CardDesc>{desc}</CardDesc>
      <CardList>
        {listItems.map((item, idx) => (
          <li key={idx}>{item}</li>
        ))}
      </CardList>
    </div>
    <AddButton selected={buttonSelected} onClick={onButtonClick}>
      {buttonText}
    </AddButton>
  </DataCard>
);

export default MoleculeDataCard;

const DataCard = styled.div`
  border: 1.5px solid ${({ selected }) => (selected ? "#4F8CFF" : "#E0E4EB")};
  background: ${({ selected }) => (selected ? "#F4F8FF" : "#fff")};
  border-radius: 12px;
  padding: 20px 18px 16px 18px;
  min-height: 150px;
  box-shadow: ${({ selected }) => (selected ? "0 0 0 2px #E3F0FF" : "none")};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  cursor: pointer;
  transition: border 0.2s, background 0.2s;
`;

const CardTitle = styled.div`
  font-size: 16px;
  font-weight: 700;
  color: #222;
  margin-bottom: 6px;
  display: flex;
  align-items: center;
  gap: 7px;
`;

const CardDesc = styled.div`
  font-size: 16px;
  color: #666;
  margin-bottom: 8px;
  text-align: left;
`;

const CardList = styled.ul`
  font-size: 13px;
  color: #4F4F4F;
  margin: 0 0 10px 0;
  padding-left: 18px;
  text-align: left;
`;

const AddButton = styled.button`
  background: ${({ selected }) => (selected ? "#4F8CFF" : "#F7F8FA")};
  color: ${({ selected }) => (selected ? "#fff" : "#4F8CFF")};
  border: none;
  border-radius: 6px;
  padding: 6px 16px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
  margin-top: 4px;
  &:hover {
    background: #4f8cff;
    color: #fff;
  }

`;